Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "CategoryList2015611699",
  {"root":"CategoryList2015611699--root"},
  "",
  4,
  "CategoryList2015611699"
);

